import Card from "components/Card/Card";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes, TinType } from "types/DataTypes";

type RRETinAdditionalInfoSectionProps = {
  control: Control<TinType>;
  getValues: UseFormGetValues<TinType>;
  setValue: UseFormSetValue<TinType>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const RRETinAdditionalInfoSection = ({
  control,
  handleFieldChange,
  constants,
}: RRETinAdditionalInfoSectionProps) => {
  return (
    <Card heading="Additional Information">
      <ControlledSelect
        control={control}
        name="tin_office_code_paperless_indicator"
        label="Paperless Indicator"
        placeholder="Select Paperless Indicator"
        errors={{}}
        options={constants?.PAPERLESS_INDICATOR || []}
        onSave={(option) =>
          handleFieldChange(
            "tin_office_code_paperless_indicator",
            option?.value,
          )
        }
      />
    </Card>
  );
};

export default RRETinAdditionalInfoSection;
